import { useHttpClient } from "@wix/fe-essentials-standalone";
import { useQueryClient } from "react-query";
import { isFigmaFrame } from "../../../api/api";

const FIGMA_VALIDATOR_QUERY_KEY = "validate-figma-url";

export const useFigmaValidatorQuery = () => {
  const httpClient = useHttpClient();
  const queryClient = useQueryClient();

  const validateFigmaFrame = async (url: string): Promise<boolean> => {
    try {
      return await queryClient.fetchQuery(
        [FIGMA_VALIDATOR_QUERY_KEY, url],
        () => isFigmaFrame({ httpClient, url }),
      );
    } catch {
      return false;
    }
  };

  return { validateFigmaFrame };
};
